import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody } from '../../common';
import { useEffectiveGroupedLocations, useEffectiveLocationIndexMap, useEffectiveQueueLocations, usePeriodChunkSize, usePlanTypeCategory } from '../selectors';
import { useWizardSimpleContext } from '../useWizardSimpleContext';
import { GlobalLocationRows, LocationTypeRows, TypeSumsTotalRow } from './bodyRows';
import { useLocationSummary, useTypeSums } from './selectors';
import { computeHighlightBorder, getYearCount } from './utils';
export var LocationTableBody = function (_a) {
  var _b;
  var name = _a.name,
    _c = _a.addColumns,
    addColumns = _c === void 0 ? [] : _c,
    _d = _a.min,
    min = _d === void 0 ? 1 : _d,
    _e = _a.max,
    max = _e === void 0 ? 99999 : _e,
    _f = _a.decimal,
    decimal = _f === void 0 ? 0 : _f,
    suffix = _a.suffix,
    disabled = _a.disabled,
    _g = _a.showTypeSums,
    showTypeSums = _g === void 0 ? false : _g,
    _h = _a.showGroupHeader,
    showGroupHeader = _h === void 0 ? false : _h,
    defaultValue = _a.defaultValue,
    _j = _a.extraColumns,
    extraColumns = _j === void 0 ? [] : _j,
    hideSticky = _a.hideSticky;
  var planTypeCategory = usePlanTypeCategory();
  var plan = ((_b = useWizardSimpleContext()) !== null && _b !== void 0 ? _b : {}).plan;
  var _k = plan !== null && plan !== void 0 ? plan : {},
    _l = _k.periodLength,
    periodLength = _l === void 0 ? 0 : _l,
    planType = _k.planType;
  var chunkSize = usePeriodChunkSize() || 1;
  var yearCount = getYearCount(periodLength, chunkSize);
  var locations = useEffectiveQueueLocations();
  var locIndexMap = useEffectiveLocationIndexMap();
  var groupedLocations = useEffectiveGroupedLocations();
  var isIncludeAverage = addColumns.includes('Average');
  var isIncludeTotal = addColumns.includes('Total');
  var hasLocations = !!locations.length;
  // Aggregation concerns live in dedicated hooks
  var _m = useLocationSummary({
      name: name,
      periodLength: periodLength,
      chunkSize: chunkSize,
      decimal: decimal
    }),
    summaryGlobal = _m.summaryGlobal,
    summary = _m.summary;
  var _o = useTypeSums({
      name: name,
      periodLength: periodLength,
      decimal: decimal,
      showTypeSums: showTypeSums
    }),
    typeSums = _o.typeSums,
    grandTotals = _o.grandTotals;
  var sharedPeriodProps = {
    periodLength: periodLength,
    chunkSize: chunkSize,
    planType: planType,
    isIncludeAverage: isIncludeAverage,
    isIncludeTotal: isIncludeTotal
  };
  var border = function (month, year) {
    return computeHighlightBorder({
      planType: planType,
      month: month,
      year: year,
      yearCount: yearCount,
      isIncludeAverage: isIncludeAverage
    });
  };
  var extraColCount = extraColumns.length;
  if (!hasLocations) {
    return _jsx(GlobalLocationRows, {
      name: name,
      min: min,
      max: max,
      decimal: decimal,
      suffix: suffix,
      disabled: disabled,
      defaultValue: defaultValue,
      extraColumns: extraColumns,
      sharedPeriodProps: sharedPeriodProps,
      border: border,
      yearCount: yearCount,
      summaryGlobal: summaryGlobal,
      hideSticky: hideSticky
    });
  }
  return _jsxs(TableBody, {
    children: [_jsx(LocationTypeRows, {
      groupedLocations: groupedLocations,
      showGroupHeader: showGroupHeader,
      showTypeSums: showTypeSums,
      locIndexMap: locIndexMap,
      summary: summary,
      typeSums: typeSums,
      name: name,
      min: min,
      max: max,
      decimal: decimal,
      suffix: suffix,
      disabled: disabled,
      defaultValue: defaultValue,
      extraColumns: extraColumns,
      sharedPeriodProps: sharedPeriodProps,
      border: border,
      yearCount: yearCount
    }), showTypeSums && _jsx(TypeSumsTotalRow, {
      planTypeCategory: planTypeCategory,
      decimal: decimal,
      suffix: suffix,
      extraColCount: extraColCount,
      grandTotals: grandTotals,
      sharedPeriodProps: sharedPeriodProps,
      border: border,
      yearCount: yearCount
    })]
  });
};